<app-payment *ngIf="initialized" [backTitle]="isAbortButton? 'Abort' : null" (eventBack)="back()" [nextTitle]="'Payment'" (eventPay)="pay()"
  [paymentEnabled]="paymentEnabled"></app-payment>
